import { useState } from "react"

const useReportControls = () => {
  const [showReport, setShowReport] = useState<boolean>(false)
  const [showTHzHeatmap, setShowTHzHeatmap] = useState<boolean>(true)
  const [showThermalHeatmap, setShowThermalHeatmap] = useState<boolean>(true)
  const [showMetalHeatmap, setShowMetalHeatmap] = useState<boolean>(true)
  const [showScanComments, setShowScanComments] = useState<boolean>(false)
  const [showVoiceNotes, setShowVoiceNotes] = useState<boolean>(false)
  const [showScanImages, setShowScanImages] = useState<boolean>(true)

  return [{
    showReport,
    showTHzHeatmapCheckbox: { value: showTHzHeatmap, onChange: () => setShowTHzHeatmap(!showTHzHeatmap) },
    showThermalHeatmapCheckbox: { value: showThermalHeatmap, onChange: () => setShowThermalHeatmap(!showThermalHeatmap) },
    showMetalHeatamapCheckbox: { value: showMetalHeatmap, onChange: () => setShowMetalHeatmap(!showMetalHeatmap) },
    showScanCommentsCheckbox: { value: showScanComments, onChange: () => setShowScanComments(!showScanComments) },
    showVoiceNotesCheckbox: { value: showVoiceNotes, onChange: () => setShowVoiceNotes(!showVoiceNotes) },
    showScanImagesCheckbox: { value: showScanImages, onChange: () => setShowScanImages(!showScanImages) },
    onShowReport: () => setShowReport(true),
    onHideReport: () => setShowReport(false)
  }]

}

export default useReportControls